import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Fab from '@mui/material/Fab';
import Zoom from '@mui/material/Zoom';

import { whatsappLink } from '../site-config';

/** Verde oficial do WhatsApp: quem vê reconhece antes de ler. */
const WHATSAPP_GREEN = '#25D366';

/**
 * Atalho fixo para a conversa, em todas as páginas. Some quando não há número.
 * Redondo no celular; com o rótulo a partir de `sm`, onde há espaço.
 */
export function WhatsAppFab() {
  const href = whatsappLink();

  if (!href) {
    return null;
  }

  return (
    <Zoom in appear style={{ transitionDelay: '600ms' }}>
      <Fab
        component="a"
        href={href}
        target="_blank"
        rel="noopener"
        aria-label="Falar no WhatsApp"
        variant="extended"
        sx={{
          position: 'fixed',
          right: { xs: 16, md: 28 },
          bottom: { xs: 16, md: 28 },
          zIndex: (theme) => theme.zIndex.speedDial,
          bgcolor: WHATSAPP_GREEN,
          color: '#FFFFFF',
          fontWeight: 700,
          textTransform: 'none',
          boxShadow: '0 12px 24px -4px rgba(37 211 102 / 0.45)',
          '&:hover': { bgcolor: '#1EBE5A' },
          // No celular, só o ícone: o rótulo cobriria o conteúdo.
          minWidth: { xs: 56, sm: 'auto' },
          height: 56,
          borderRadius: 28,
          px: { xs: 0, sm: 2.5 },
          '& .label': { display: { xs: 'none', sm: 'inline' }, ml: 1 },
        }}
      >
        <WhatsAppIcon sx={{ fontSize: 28 }} />
        <span className="label">Fale no WhatsApp</span>
      </Fab>
    </Zoom>
  );
}
